export enum ImportantNoticeSource {
  Internal = 1,
  External = 2,
}

export interface ImportantNoticeDismissalStatus {
  isDismissed: boolean;
  dismissedAt: string | null;
}
